export default __webpack_public_path__ + "assets/images/icon-close.743e73b3fed403213a442d74a354ed03.svg";